export class UnrestrictedEntityUpdate {
  entityId = '';
  revision = 0;
  estimatedShipDate: Date | null = null;
  erpStatus = '';
  updateUser = '';
  costFactor: number | null = null;
  internalNotes: string | undefined = undefined;
}
